// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"732":"92ec3498","977":"98310e2c"}[chunkId] + ".chunk.js";
};